export const CLIENT_SCOPE_STORAGE_KEY = 'client-scope';
export const CLIENT_SCOPE_HEADER = 'X-Client-Scope';

export const normalizeClientScopeId = (value) => {
    if (value === null || value === undefined || value === '') {
        return null;
    }

    const normalizedValue = Number.parseInt(value, 10);

    return Number.isNaN(normalizedValue) ? null : normalizedValue;
};

export const applyClientScopeSelection = (clientId, store = null) => {
    const normalizedClientId = normalizeClientScopeId(clientId);

    if (typeof window !== 'undefined' && window.axios?.defaults?.headers?.common) {
        if (normalizedClientId === null) {
            delete window.axios.defaults.headers.common[CLIENT_SCOPE_HEADER];
        } else {
            window.axios.defaults.headers.common[CLIENT_SCOPE_HEADER] = normalizedClientId;
        }
    }

    if (typeof window !== 'undefined' && window.localStorage) {
        if (normalizedClientId === null) {
            window.localStorage.removeItem(CLIENT_SCOPE_STORAGE_KEY);
        } else {
            window.localStorage.setItem(CLIENT_SCOPE_STORAGE_KEY, normalizedClientId);
        }
    }

    if (store?.state?.clientScope) {
        store.state.clientScope.selectedClientId = normalizedClientId;
    }

    return normalizedClientId;
};

export const initializeClientScope = (store = null) => {
    const storedClientId = typeof window !== 'undefined' && window.localStorage
        ? window.localStorage.getItem(CLIENT_SCOPE_STORAGE_KEY)
        : null;

    return applyClientScopeSelection(storedClientId, store);
};

export const resolveClientScopeContext = (user = {}, store = null) => {
    const authorizedClients = Array.isArray(user.authorized_clients)
        ? user.authorized_clients.map((client) => ({
            id: normalizeClientScopeId(client.id),
            name: client.name,
        })).filter((client) => client.id !== null)
        : [];

    const isClientScoped = Boolean(user.is_client_scoped) && authorizedClients.length > 0;
    const availableClientIds = authorizedClients.map((client) => client.id);
    const storedClientId = typeof window !== 'undefined' && window.localStorage
        ? normalizeClientScopeId(window.localStorage.getItem(CLIENT_SCOPE_STORAGE_KEY))
        : null;
    const payloadClientId = normalizeClientScopeId(user.selected_client_id);

    let selectedClientId = null;

    if (isClientScoped) {
        if (availableClientIds.includes(storedClientId)) {
            selectedClientId = storedClientId;
        } else if (availableClientIds.includes(payloadClientId)) {
            selectedClientId = payloadClientId;
        } else if (availableClientIds.length === 1) {
            selectedClientId = availableClientIds[0];
        }
    }

    applyClientScopeSelection(selectedClientId, store);

    return {
        isClientScoped,
        authorizedClients,
        selectedClientId,
    };
};

export const selectClientScope = (clientId, clients = [], store = null) => {
    const availableClientIds = clients
        .map((client) => normalizeClientScopeId(client.id))
        .filter((value) => value !== null);

    const normalizedClientId = normalizeClientScopeId(clientId);

    return applyClientScopeSelection(
        availableClientIds.includes(normalizedClientId) ? normalizedClientId : null,
        store
    );
};
